import { React, useEffect, useMemo } from "react";
import ReactGA from "react-ga4";
import useAnalyticsEventTracker from "./useAnalyticsEventTracker";

import heroBackground from "../images/unsplash-image-tMHAmxLyzvA.jpg";
import bshcLogo from "../images/BSHClogo_CareSol_Wh.png";
import supportImage from "../images/image-asset.jpeg";
import archangelsLogo from "../images/Archangels_Logo_LargeUse_RGB_DayBlue_on_TransparentBackground.png";

const REFERRAL_BASE_URL =
  "https://elderinfo.org/referrals/FCS_Referral_Form_CII.aspx";

const trackHubSpotReferralClick = () => {
  const _hsq = (window._hsq = window._hsq || []);
  const token = new URLSearchParams(window.location.search).get("token");
  const payload = [
    "trackCustomBehavioralEvent",
    {
      name: "pe20676831_bshc_referral_button_click",
      properties: {
        full_cii_url: window.location.href,
        token: token || "",
      },
    },
  ];
  console.log("HubSpot event:", payload);
  _hsq.push(payload);
};

const MessageComponent = () => {
  const gaEventTracker = useAnalyticsEventTracker("Boston Senior Home Care");

  const supportUrl = useMemo(() => {
    const currentParams = new URLSearchParams(window.location.search);
    const outgoingParams = new URLSearchParams();

    const token = currentParams.get("token");
    if (token) {
      outgoingParams.set("token", token);
    }

    currentParams.forEach((value, key) => {
      if (key.toLowerCase().startsWith("utm_")) {
        outgoingParams.set(key, value);
      }
    });

    const query = outgoingParams.toString();
    return query ? `${REFERRAL_BASE_URL}?${query}` : REFERRAL_BASE_URL;
  }, []);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: `${window.location.pathname}${window.location.search}`,
      title: "BSHC Microsite",
    });
  }, []);

  return (
    <main className="bshc-page">
      <section
        className="bshc-section bshc-hero"
        style={{ backgroundImage: `url(${heroBackground})` }}
      >
        <div className="bshc-hero-overlay" />
        <div className="bshc-shell bshc-hero-content">
          <img className="bshc-mark" src={bshcLogo} alt="Boston Senior Home Care" />
          <h1>Support on standby.</h1>
          <p>
            If you&apos;re the "go to" for others, the Caregiver Solutions program
            at Boston Senior Home Care is here to support you the way you support
            everyone else.
          </p>
          <a
            href={supportUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="bshc-btn bshc-btn-support"
            onClick={() => { gaEventTracker("Start my support", "hero"); trackHubSpotReferralClick(); }}
          >
            Start my support
          </a>
        </div>
      </section>

      <section className="bshc-section bshc-info">
        <div className="bshc-shell bshc-info-grid">
          <div>
            <h3 className="bshc-stat">
              <span>70%</span> of us feel better knowing resources exist (whether or
              not we use them).
            </h3>
            <p>
              When you <em>do</em> want to use them, here are some of the things the
              Caregiver Solutions program can hook you up with:
            </p>
            <ul>
              <li>A stipend for the care you give someone else.</li>
              <li>Gift cards you can use on groceries, transportation, and more.</li>
              <li>Ring cameras, Echos and iPads so you can monitor from afar.</li>
              <li>Help with the grandkids.</li>
            </ul>
            <p>
              Not the time? Save the link to this page. (Future you will thank you.)
            </p>
          </div>
          <div className="bshc-dark-card">
            <p>
              There is literally no CATCH. Support is available to you <strong>at
              no cost</strong>. It only takes a few minutes to apply, then a
              Caregiver Advisor will be in touch.
              </p>

            <a
              href={supportUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bshc-btn bshc-btn-support"
              onClick={() => { gaEventTracker("Start my support", "mid-page"); trackHubSpotReferralClick(); }}
            >
              Start my support
            </a>
            
          </div>
        </div>
      </section>

      <section className="bshc-section bshc-about">
        <div className="bshc-shell bshc-about-grid">
          <div className="bshc-about-image-wrap">
            <img src={supportImage} alt="Caregiver support" className="bshc-about-image" />
          </div>
          <div className="bshc-about-copy">
            <h3>This isn&apos;t you asking. This is us offering.</h3>
            <p>
              With 50+ years of experience serving the Greater Boston area,
              Boston Senior Home Care (BSHC) is a trusted community resource.
            </p>
            <p>
              ARCHANGELS has partnered with BSHC to connect folks like you (aka,
              the ones caring A LOT) to their Caregiver Solutions program. Once
              you&apos;ve filled out the contact form, your dedicated Care Advisor
              will meet with you to understand your situation and connect you
              directly to the services and resources best suited for your care
              reality.
            </p>
            <a
              href="https://bshcinfo.org/about-us/"
              target="_blank"
              rel="noopener noreferrer"
              className="bshc-btn"
              onClick={() => gaEventTracker("About BSHC")}
            >
              About BSHC
            </a>
          </div>
        </div>
      </section>

      <footer className="bshc-footer">
        <div className="bshc-shell bshc-powered">
          <span>POWERED BY:</span>
          <img src={archangelsLogo} alt="Archangels" />
        </div>
      </footer>
    </main>
  );
};

export default MessageComponent;
